import apiClient from './client'
import type {
  Coach,
  Group,
  CreateCoachRequest,
  UpdateCoachRequest,
  AssignCoachToGroupRequest,
} from '@shared/types/api'

export const coachesApi = {
  // POST /api/v1/assistants/{assistantId}/coaches - создать тренера
  create: async (assistantId: string, data: CreateCoachRequest): Promise<Coach> => {
    const response = await apiClient.post<Coach>(`/assistants/${assistantId}/coaches`, data)
    return response.data
  },

  // GET /api/v1/coaches/{id} - получить тренера
  getById: async (id: string): Promise<Coach> => {
    const response = await apiClient.get<Coach>(`/coaches/${id}`)
    return response.data
  },

  // GET /api/v1/assistants/{assistantId}/coaches - список тренеров ассистента
  getByAssistantId: async (assistantId: string): Promise<Coach[]> => {
    const response = await apiClient.get<Coach[]>(`/assistants/${assistantId}/coaches`)
    return response.data
  },

  // PUT /api/v1/coaches/{id} - обновить тренера
  update: async (id: string, data: UpdateCoachRequest): Promise<Coach> => {
    const response = await apiClient.put<Coach>(`/coaches/${id}`, data)
    return response.data
  },

  // GET /api/v1/assistants/{assistantId}/coaches/search - поиск тренеров
  search: async (assistantId: string, query: string): Promise<Coach[]> => {
    const response = await apiClient.get<Coach[]>(
      `/assistants/${assistantId}/coaches/search`,
      { params: { q: query } }
    )
    return response.data
  },

  // POST /api/v1/coaches/{coachId}/assign-group - привязать тренера к группе
  assignToGroup: async (coachId: string, data: AssignCoachToGroupRequest): Promise<void> => {
    await apiClient.post(`/coaches/${coachId}/assign-group`, data)
  },

  // POST /api/v1/coaches/{coachId}/remove-group - отвязать тренера от группы
  removeFromGroup: async (coachId: string, groupId: string): Promise<void> => {
    await apiClient.post(`/coaches/${coachId}/remove-group`, { group_id: groupId })
  },

  // GET /api/v1/groups/{groupId}/coaches - получить тренеров группы
  getByGroupId: async (groupId: string): Promise<Coach[]> => {
    const response = await apiClient.get<Coach[]>(`/groups/${groupId}/coaches`)
    return response.data
  },

  // GET /api/v1/coaches/{coachId}/groups - получить группы тренера
  getGroupsByCoachId: async (coachId: string): Promise<Group[]> => {
    const response = await apiClient.get<Group[]>(`/coaches/${coachId}/groups`)
    return response.data
  },

  // DELETE /api/v1/coaches/{id} - удалить тренера
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/coaches/${id}`)
  },
}
